@use "app/styles/colors" as colors;

.section {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 3rem;
  margin-left: var(--root-bleed);
  margin-right: var(--root-bleed);
  margin-bottom: calc(min(0.55rem, max(0.25rem, 1.3dvw)) * 26);
  padding: 2rem;
  border-radius: 2rem;
  border: 3px solid transparent;
  @include colors.section("blue");

  @media (prefers-color-scheme: light) {
    background-color: var(--section-color-dim);
  }
  @media (prefers-color-scheme: dark) {
    background-origin: border-box;
    background-clip: padding-box, border-box;
    background-image:
      linear-gradient(var(--color-background), var(--color-background)),
      linear-gradient(to right, var(--section-color), var(--section-color-alt));
  }
  @media (min-width: 48rem) {
    padding: 3rem;
  }
  @media (min-width: 64rem) {
    border: none;
    background-image: none;
    background-color: transparent;
    margin-bottom: 4rem;
    padding: 0 4rem;
    flex-direction: row;
    align-items: center;
  }
}

.content {
  display: flex;
  flex-direction: column;
  order: 0;
  max-width: 35rem;

  @media (min-width: 90rem) {
    margin-left: 0;
  }

  h2 {
    font-size: max(2.8rem, min(3.3rem, 8dvw));
    margin-bottom: 1.25rem;
  }

  p {
    font-size: 1.1rem;
    margin: 1rem 0;
  }
}

.headingText {
  display: inline-flex;
  color: var(--section-color-dark);
  @media (prefers-color-scheme: dark) {
    color: var(--color-foreground);
  }
  @media (prefers-color-scheme: light) and (min-width: 64rem) {
    background-clip: text;
    color: transparent;
    background-image: linear-gradient(
      to right,
      var(--section-color-dark),
      var(--section-color-light)
    );
  }
}

.demo {
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: -12em;
  font-size: min(0.55rem, max(0.3rem, 1.4dvw));
  align-items: center;
  border-radius: 2rem;
  background-origin: border-box;
  background-clip: padding-box, border-box;
  @media (min-width: 52rem) {
    margin-top: -6rem;
    align-self: flex-end;
    justify-content: flex-end;
  }
  @media (min-width: 64rem) {
    justify-content: flex-start;
    max-width: 38rem;
    min-height: 26rem;
    margin-top: 0;
    margin-bottom: 0;
    padding: 4rem;
    padding-top: 6rem;
    padding-bottom: 5rem;
    margin-left: 3rem;
    margin-right: var(--root-bleed);
    @media (prefers-color-scheme: light) {
      &::before {
        z-index: -1;
        pointer-events: none;
        user-select: none;
        content: "";
        position: absolute;
        inset: 0;
        background: var(--section-color-dim);
        border-radius: 2rem;
        clip-path: polygon(
          0 0,
          100% 0,
          100% calc(100% - 4rem),
          calc(100% - 4rem) 100%,
          0 100%,
          0 0
        );
      }
    }
    @media (prefers-color-scheme: dark) {
      border: 3px solid transparent;
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      background-image:
        linear-gradient(var(--color-background), var(--color-background)),
        linear-gradient(
          to right,
          var(--section-color-alt),
          var(--section-color),
          transparent
        );
    }
  }
}

.example {
  flex: 1;
  display: flex;
  position: relative;
  border-radius: 1rem;
  width: 100%;
  max-width: 60em;
  padding: 1rem;
  padding-top: 4rem;
  background-color: color-mix(
    in srgb,
    var(--color-black),
    var(--section-color-dark) 15%
  );
  &::before {
    position: absolute;
    inset: 0;
    z-index: -1;
    transform: scale(0.8, 0.8);
    content: "";
    background-color: var(--section-color-dim-alt);
    filter: blur(50px);
    opacity: 0.8;
  }
  @media (prefers-color-scheme: dark) {
    border: 2px solid var(--section-color-dim);
  }

  @media (min-width: 40rem) {
    width: 52em;
  }

  @media (min-width: 64rem) {
    padding: 2rem;
    padding-top: 4rem;
    padding-right: 6rem;
    max-width: 30rem;
    margin-left: -7rem;
  }

  :global(.code-block) {
    width: 100%;
  }

  pre {
    overflow: visible;
    padding: 0;
    border: none;
    background-color: transparent !important;
    font-size: max(0.8rem, min(1.5rem, 3.7dvw));
  }
}

.menuBar {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  top: 0;
  left: 0;
  right: 0;
  gap: 0.5rem;
  padding-left: 0.5rem;
  height: 2.5rem;
  border-radius: 1rem 1rem 0 0;
  background-image: linear-gradient(to bottom, #f6f6f6 0, #ddd);
  @media (prefers-color-scheme: dark) {
    top: -2px;
    left: -2px;
    right: -2px;
  }
}

.menuBarRed,
.menuBarYellow,
.menuBarGreen {
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  border: 1px solid #000;
}
.menuBarRed {
  background: #ff6159;
  border-color: #e0453e;
}
.menuBarYellow {
  background: #ffbd2e;
  border-color: #e09e19;
}
.menuBarGreen {
  background: #28ca42;
  border-color: #10ab24;
}
